import FormElements from '../constants/behavior_form_elements';

export const getFormElementAPI = (formAPI, objectWithElement) => {
	const { element } = objectWithElement;

	switch(element) {
		case FormElements.FORM:
			return formAPI;
		case FormElements.FIELD:
			return getFieldAPI(formAPI, objectWithElement);
		case FormElements.ACTION:
			return getActionAPI(formAPI, objectWithElement);
		case FormElements.GRID:
			return getGridAPI(formAPI, objectWithElement);
	}
};

export const getFieldAPI = (formAPI, objectWithElement) => {
	const { fieldId } = objectWithElement;
	let fieldAPI = formAPI.fields(fieldId);
	if(!fieldAPI) {
		fieldAPI = getGridFieldAPI(formAPI, objectWithElement);
	}

	return fieldAPI;
};

export const getActionAPI = (formAPI, objectWithElement) => {
	const { fieldId, actionId } = objectWithElement;
	let actionAPI;
	if (fieldId) {
		actionAPI = getFieldAPI(formAPI, objectWithElement).actions(actionId);
	} else {
		actionAPI = formAPI.actions(actionId);
	}
	if (!actionAPI) {
		actionAPI = getFieldAPI(formAPI, { fieldId: objectWithElement.actionId })
			.actions()
			.find(action => action.id.match(objectWithElement.actionId).length);
	}
	return actionAPI;
};

const getGridFieldAPI = (formAPI, objectWithElement) => {
	const { gridId, fieldId } = objectWithElement;
	if(gridId)
		return formAPI.fields(gridId).fields(fieldId);

	return formAPI.fields()
		.filter(field => field.component() === 'gridform')
		.map(grid => grid.fields())
		.reduce((acc, fields) => acc.concat(fields) , [])
		.filter(gridField => gridField.id === fieldId)[0];
};

const getGridAPI = (formAPI, objectWithElement) => {
	const { gridId } = objectWithElement;

	if(gridId) return formAPI.fields(gridId);

	throw new Error(`form.errors.behavior.event.invalid_element`);
};

export default {
	getFormElementAPI,
	getFieldAPI,
	getActionAPI,
	getGridAPI,
};
